<ngx-spinner  bdColor="rgba(128, 128, 128, 0.8)"
              size="default"
              color="#2f9cf2"
              type="line-scale-pulse-out"
              [name]="spinnerName"
              [fullScreen]="false"><p style="color:white">{{spinnerText}}</p></ngx-spinner>

<p-toast position="top-right"></p-toast>

<p-toolbar>
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items"></p-breadcrumb>
  </div>
</p-toolbar>

<p-splitter [style]="{'height': 'calc(100% - 36px)'}" layout="{{smallScreen ? 'vertical' : 'horizontal'}}" [panelSizes]="[40,60]" [gutterSize]="8">
  <ng-template pTemplate>
    <div class="section-title">Roles</div>
    <div style="height: calc(100% - 30px); width:100%">
      <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          [rowData]="roles"
          [columnDefs]="roleGridHeaders"
          [context]="context"
          rowSelection="single"
          (gridReady)="onRoleGridReady($event)"
          (selectionChanged)="onRoleSelectionChanged($event)"></ag-grid-angular>
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div class="section-title">Permission Settings</div>
    <div style="height: calc(100% - 30px); width:100%">
      <ag-grid-angular
          style="width: 100%; height:100%;"
          class="ag-theme-alpine"
          [rowData]="roleOperations"
          [columnDefs]="roleOperationGridHeaders"
          [context]="context"
          rowSelection="single"
          (gridReady)="onRoleOperationGridReady($event)"></ag-grid-angular>
    </div>

  </ng-template>
</p-splitter>